// extracted by mini-css-extract-plugin
export default {"modal":"_15P0g","root":"_2GeQK","text":"_3aE4z","options":"_2aXkm","footer":"X_nSm"};